import { render, staticRenderFns } from "./FichaRefBibliograficas.vue?vue&type=template&id=5afd74eb&"
import script from "./FichaRefBibliograficas.vue?vue&type=script&lang=js&"
export * from "./FichaRefBibliograficas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports